document.addEventListener('DOMContentLoaded', () => {
    // Elements
    const nameInput = document.querySelector('.form-group__name .items__inputs--input');
    const emailInput = document.querySelector('.form-group__email .items__inputs--input');
    const phoneInput = document.querySelector('.form-group__phone .items__inputs--input');
    const companyInput = document.querySelector('.form-group__company .items__inputs--input');
    const messageTextArea = document.querySelector('.form-group__message .items__inputs-area--textarea');
    const messageCounter = document.querySelector('#current');
    const submitBtn = document.querySelector('.btn--medium');
    const emailError = document.querySelector('.form-group__email .items__inputs');
    const emailErrorMessage = document.querySelector('.form-group__email .error-message');

    emailErrorMessage.style.display = 'none';
  
    // Event Handlers
    messageTextArea.addEventListener('input', () => {
      messageCounter.textContent = messageTextArea.value.length;
    });
  
    emailInput.addEventListener('blur', () => {
        if (emailInput.value === '') {
            emailInput.classList.remove('error');
            emailInput.nextElementSibling.style.display = 'none'; // Hide the error message
        } 
        else if (!isValidEmail(emailInput.value)) {
            emailInput.classList.add('error');
            emailInput.nextElementSibling.style.display = 'block'; // Show the error message
        } 
        else {
            emailInput.classList.remove('error');
            emailInput.nextElementSibling.style.display = 'none'; // Hide the error message
        }
      });
  
    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
  
      // Form validation
      if (
        nameInput.value === '' ||
        emailInput.value === '' ||
        phoneInput.value === '' ||
        companyInput.value === '' ||
        messageTextArea.value === ''
      ) {
        alert('Please fill out all fields.');
        return;
      }
  
      if (!isValidEmail(emailInput.value)) {
        emailError.classList.add('error');
        emailInput.nextElementSibling.style.display = 'block'; // Show the error message
        return;
      } else {
        emailError.classList.remove('error');
        emailInput.nextElementSibling.style.display = 'none'; // Hide the error message
      }
  
      // Simulating sending data
      sendData({
        name: nameInput.value,
        email: emailInput.value,
        phone: phoneInput.value,
        company: companyInput.value,
        message: messageTextArea.value
      });
    });
  
    // Helper Functions
    function isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(email);
    }
  
    function sendData(data) {
      // Construct the email body
      var emailBody = 'Name: ' + encodeURIComponent(data.name) + '%0D%0A' +
      'Email: ' + encodeURIComponent(data.email) + '%0D%0A' +
      'Phone: ' + encodeURIComponent(data.phone) + '%0D%0A' +
      'Company: ' + encodeURIComponent(data.company) + '%0D%0A' +
      'Message: ' + encodeURIComponent(data.message);
    
      // Create the mailto link
      var mailtoLink = 'mailto:hello@winwinza.com?subject=' +
                       encodeURIComponent('New Contact Form Submission') +
                       '&body=' + emailBody;
    
      // Open the mailto link in a new window/tab
      window.open(mailtoLink, '_blank');
    }
  });
  